import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import userImage from '../../../assets/128x128.jpg';
import api from '../../../utils/api';
import {withRouter, Link} from 'react-router-dom';
import ReactHighcharts from 'react-highcharts';
import ReactHighmaps from 'react-highcharts/ReactHighmaps';
import * as AdminActions from '../../../store/actions/adminActions';
import Boundary from '../../Boundary.js';
import Counter from '../../Dashboard/DashboardUser/Counter';
import send from '../../../utils/ChatServer.js';
import DatePicker from 'react-datepicker';

import { WithContext as ReactTags } from 'react-tag-input';
import {NotificationManager} from "react-notifications";

const KeyCodes = {
    comma: 188,
    enter: 13,
};

const delimiters = [KeyCodes.comma, KeyCodes.enter];

/* global $ */

class Student extends Component {
    constructor(props){
        super(props);


        this.defaultNote = {
            content: '',
            type: 'phone',
            avatar: this.props.profile.image,
            senderName: this.props.profile.name + ' ' + this.props.profile.lname,
            created: new Date(),
            createdBy: this.props.user.user.id,
            courseUserId: this.props.student.id,
            profileId: this.props.student.profileId,
            courseId: this.props.student.courseId,
            senderProfileId: this.props.profile.id,

        }

        this.state = {
            subjectOpen: false,
            modalOpen: false,
            note: JSON.parse(JSON.stringify(this.defaultNote)),
            contentError: false,
            tags: [],
            suggestions: [],
            status: '',
            access: undefined,
            addToCourse: ''

        }

        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    componentDidMount(){
        this.init();
    }

    init = () => {
        let {student} = this.props;
        // console.log("Initting");
        if(this.props.student.tags) {
            if(JSON.stringify(this.props.student.tags) !== JSON.stringify(this.state.tags)) {
                this.setState({status: student.status, access: student.access, tags: this.props.student.tags.map(t => {
                        return {
                            id: t,
                            text: t
                        }

                })});
            }
        }
        //this.props.getStudent(this.props.id, null, this.props.user.user.id, this.props.user.id);
    }

    getStudentNotes = () => {
        let {student} = this.props;
        let skip = 0;
        if(student.notes) {
            if(student.notes.length){
                skip = student.notes.length;
            }
        }

        this.props.getStudentNotes(student.id, skip, 10, this.props.user.id);
    }

    renderImg = (row) => {
        if(row){
            let avatar = userImage;
            if(row.avatar){
                if(row.avatar.indexOf('http') > -1){
                    avatar = row.avatar;
                }else{
                    avatar = api.makeFileURL(row.avatar, this.props.user.id);
                }
            }
            return (
                <img
                    src={avatar}
                    alt={row.name}
                />
            )
        }else{
            return (
                <img
                    src={userImage}
                    alt={row.name}
                />
            )
        }
    };

    renderWeekStudy = (t) => {
        let {student} = this.props;
        let yd = moment().subtract(t, 'day').format('YYYY-MM-DD');
        let seconds = student.studied.filter(s => moment().diff(moment(s.date), 'days') < t).map(s => s.time).reduce((a, b) => a + b, 0);
        let dur = moment.duration(seconds, 'seconds');
        return (
            <span>
                {dur.hours() + ' Hours ' + dur.minutes() + ' Minutes'}
            </span>
        )
    }

    renderStudy = () => {
        let {student} = this.props;
        let yd = moment().subtract(1, 'day').format('YYYY-MM-DD');
        let seconds = student.studied.filter(s => s.date === yd).map(s => s.time).reduce((a, b) => a + b, 0);
        let dur = moment.duration(seconds, 'seconds');
        return (
            <span>
                {dur.hours() + ' Hours ' + dur.minutes() + ' Minutes'}
            </span>
        )
    }

    ShowSubject = (target, subjectId, e) => {
        let btn = e.currentTarget;
        this.props.getSingleUserSubject(this.props.student.id, subjectId, this.props.user.id);
        if($(btn).hasClass("ActiveSubjectClass")){
            $(btn).removeClass("ActiveSubjectClass");
            $(target).slideUp();
            //this.setState({subjectOpen: false});
        }else{
            $(".student-panel-subjects-list li a").removeClass("ActiveSubjectClass");
            $(btn).addClass("ActiveSubjectClass");
            $(target).slideDown();
            //this.setState({subjectOpen: true});
        }
        e.preventDefault();
    }

    renderSubject = (id, i) => {

        let subject = {};
        let {student} = this.props;
        let percentComplete = 0;
        if(this.props.studentSubjects.filter(s => s.id === id).length > 0) {
            subject = this.props.studentSubjects.filter(s => s.id === id)[0];
        }

        if(subject.name){
            if(student.stats){
                if(student.stats.completion){
                    if(student.stats.completion.chart){
                        let chart = student.stats.completion.chart[0];
                        if(chart.data){
                            let chartSubject = chart.data.filter(d => d.name === subject.name);
                            if(chartSubject[0]){
                                percentComplete = chartSubject[0].y;
                            }
                        }
                    }
                }
            }
        }

        let target = '#' + student.id;
        return (
            <li key={i}>
                <a href="#" onClick={e => this.ShowSubject(target, subject.id, e)}>{subject.name}</a>
                <div className="StudentPanelProgressBarWrap"><div className="StudentPanelProgressBar" style={{width: String(percentComplete) + '%'}}></div></div>
            </li>
        )
    }

    renderUserSubject = () => {
        let {student} = this.props;
        if(student.cs){
            return (
                <div className="allSubjectsStudent subj-Phy" id={student.id} style={{display: this.state.subjectOpen ? 'block' : 'none'}}>
                    <div className="student-panel-subject-details-header">
                        <div className="student-panel-subject-icon">
                            <i className="zmdi zmdi-check-circle"></i>
                            <span>
                                {student.cs.name.substring(0, 3)}
                            </span>
                        </div>
                        <div className="student-stats-student-panel-wrap">
                            <div className="student-stats-student-panel">
                                <p>Start Date</p>
                                <h4>{student.cs.created ? moment(student.cs.created).format('DD MMM YYYY') : '-'}</h4>
                            </div>
                            <div className="student-stats-student-panel">
                                <p>End Date</p>
                                <h4>{student.cs.end ? moment(student.cs.end).format('DD MMM YYYY') : '-'}</h4>
                            </div>
                            <div className="student-stats-student-panel">
                                <p>Days Taken</p>
                                <h4>{student.cs.daysTaken} Days</h4>
                            </div>
                            <div className="student-stats-student-panel">
                                <p>Subject Repeat</p>
                                <h4>{student.cs.repeats || 0}</h4>
                            </div>
                            <div className="student-stats-student-panel">
                                <p>Deadline Met</p>
                                <h4>
                                    {student.cs.deadlineMet ?
                                    <i className="zmdi zmdi-check-circle font-16 text-green"></i>
                                    : 
                                    <i className="zmdi zmdi-close font-16 text-danger"></i>
                                    }
                                    </h4>
                            </div>
                        </div>
                    </div>
                    <div className="student-panel-subject-details-body">
                        <table className="table table-striped student-panel-subject-details-table">
                            <thead>
                                <tr>
                                    <th>Lectures</th>
                                    <th>Time</th>
                                    <th>Attempts</th>
                                    <th>Score</th>
                                </tr>
                            </thead>
                            <tbody>
                                {student.cs.lectures ?
                                    student.cs.lectures.map((l, i) => {
                                        return (
                                            <tr>
                                                
                                                <td>{l.title || l.name}</td>
                                                <td>
                                                    {l.ul ?
                                                        moment.duration(l.ul.userTime * 1000).hours() + 'hr ' +
                                                        moment.duration(l.ul.userTime * 1000).minutes() + 'min'
                                                    : '-'}
                                                </td>
                                                <td>
                                                    {l.ul ?
                                                        l.ul.attempts
                                                    : '-'}
                                                </td>
                                                
                                                    {l.ul ?
                                                        <td>
                                                            <span>{l.ul.attentiveness}%</span> - <span>{l.ul.efficiency}%</span> - <span>{l.ul.quiz}%</span>
                                                        </td>
                                                    : 
                                                        <td>
                                                            <span>N/A</span> - <span>N/A</span> - <span>N/A</span>
                                                        </td>
                                                    }
                                                    
                                                
                                            </tr>
                                        )
                                    })
                                : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            )
        }else{
            return (
                <div className="allSubjectsStudent subj-Phy" id={student.id} style={{display: this.state.subjectOpen ? 'block' : 'none'}}>

                </div>
            );
        }
    }

    openNoteForm = (e, note) => {
        let {student} = this.props;

        if(note){
            this.setState({note: JSON.parse(JSON.stringify(note))});
        }

        $(`#NoteForm-${student.id}`).stop().slideToggle();

        e.preventDefault();
    }

    deleteNote = (e, note) => {
        e.preventDefault();
        let data = {
            type: 'DELETE_CU_NOTE',
            note: note,
            token: this.props.user.id
        };
        send(data, this.props.socket, this.props.user.id);
    }

    submitNoteForm = (e) => {
        e.preventDefault();

        if(this.state.note.content){

            let data = {
                type: 'ADD_CU_NOTE',
                note: this.state.note,
                token: this.state.note.createdBy
            };
            send(data, this.props.socket, this.props.user.id);
            this.setState({note: JSON.parse(JSON.stringify(this.defaultNote))}, () => {
                this.openNoteForm(e, null);
            });
        }else{
            this.setState({contentError: true});
        }


    }

    handleDelete(i) {
        const { tags } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
        });
    }

    handleAddition(tag) {
        this.setState(state => ({ tags: [...state.tags, tag] }));
    }

    handleDrag(tag, currPos, newPos) {
        const tags = [...this.state.tags];
        const newTags = tags.slice();

        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);

        // re-render
        this.setState({ tags: newTags });
    }

    saveChanges = (e) => {
        e.preventDefault();

        let data = {
            access: this.state.access,
            tags: this.state.tags.map(t => t.text),
            addToCourse: this.state.addToCourse
        }

        if (this.state.status) {
            data.status = this.state.status;
        } else {
            data.status = this.props.student.status;
        }


        this.props.saveStudent(this.props.student.id, data, this.props.user.id);



    }

    renderEditModal = () => {
        let {student} = this.props;
        const { tags, suggestions } = this.state;

        return (
            <div className="modal fade in" id={`OptionsModal-${student.id}`} style={{display: 'none'}}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            <h4 className="modal-title">Update Student Details</h4>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <label>Status</label>
                                <div className="form-select-overlay">
                                    <select className="form-control" value={this.state.status} onChange={e => this.setState({status: e.target.value})}>
                                        <option value="approved">Active</option>
                                        <option value="blocked">Hold</option>
                                        <option value="blocked">Expel</option>
                                        <option value="blocked">Remove</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Access</label>
                                <div>
                                <DatePicker
                                    selected={this.state.access ? moment(this.state.access) : this.state.access}
                                    name="access"
                                    className="form-control"
                                    onChange={e => {
                                        if(moment(e).diff(moment(), 'days') >= 0){
                                            this.setState({access: e});
                                        }else{
                                            NotificationManager.error('Select a future date');
                                        }
                                    }
                                }
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    yearDropdownItemNumber={15}
                                    />
                                        </div>

                            </div>

                            <div className="form-group">
                                <label>Add to course</label>
                                <div className="form-select-overlay">
                                    <select className="form-control" value={this.state.addToCourse} onChange={e => this.setState({addToCourse: e.target.value})}>
                                        <option value="">Select a course</option>
                                        {this.props.adminCourses.map(c => {
                                            return (
                                                <option value={c.id}>{c.name}</option>
                                            )
                                            })}

                                    </select>
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Next Payment</label>
                                <input type="text" className="form-control datapicker" name="next_payment" placeholder="MM/DD/YYYY" />
                                <i className="zmdi zmdi-calendar"></i>
                                <span className="help-block"></span>
                            </div>

                            <div className="form-group">
                                <label>Tags</label>
                                <ReactTags tags={tags}
                                classNames={{
                                    tags: 'ReactTags__tags form-control',

                                }}
                                    suggestions={suggestions}
                                    handleDelete={this.handleDelete}
                                    handleAddition={this.handleAddition}
                                    handleDrag={this.handleDrag}
                                    delimiters={delimiters} />
                            </div>

                            <div className="form-group">
                                <label>Add To Group</label>
                                <input type="text" className="form-control" />
                            </div>

                            


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal" onClick={e => this.saveChanges(e)}>Save changes</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderNotesModal = () => {
        let {student} = this.props;
        return (
            <div className="modal fade in" id={`NotesModal-${student.id}`} style={{display: 'none'}}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                            <h4 className="modal-title">Notes About {student.name || student.pname}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="text-right sm-bottom30">
                                <a href="#" onClick={e => this.openNoteForm(e, null)} className="btn btn-default">Add New Note</a>
                            </div>
                            <div className="new_note_form" id={`NoteForm-${student.id}`} style={{display: 'none'}}>
                                {this.state.contentError ?
                                    <div className="text-danger">You need to add some text</div>
                                : null}
                                <div className="form-group">
                                    <label>Note</label>
                                    <textarea className="form-control" style={{minHeight: '100px'}} value={this.state.note.content} onChange={e => {
                                        let {note, contentError} = this.state;
                                        note.content = e.target.value;
                                        if(e.target.value.length > 0){
                                            contentError = false;
                                        }
                                        this.setState({note, contentError});
                                    }}></textarea>
                                </div>
                                <div className="form-group">
                                    <label>Note Type</label>
                                    <div className="form-select-overlay">
                                        <select className="form-control" value={this.state.note.type} onChange={e => {
                                            let {note} = this.state;
                                            note.type = e.target.value;
                                            this.setState({note});
                                        }}>
                                            <option value="phone">Phone</option>
                                            <option value="messenger">Messenger</option>
                                            <option value="person">In-Person</option>
                                            <option value="email">Email</option>
                                            <option value="personal">Personal</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <input type="submit" className="btn btn-primary" value="Save Note" onClick={e => this.submitNoteForm(e)} />
                                </div>
                            </div>
                            <table className="table table-striped">
                                <tbody><tr>
                                    <td>Note</td>
                                    <td>By</td>
                                    <td>Type</td>
                                    <td>Date</td>
                                </tr>
                                {student.notes ?
                                    student.notes.map((s, i) => {
                                        return (
                                            <tr>
                                                <td>
                                                    <p>{s.content}</p>
                                                    <p><a href="#" onClick={e => this.openNoteForm(e, s)}>Edit</a> | <a href="#" onClick={e => this.deleteNote(e, s)}>Remove</a></p>
                                                </td>
                                                <td><div className="person-with-image-and-name">{this.renderImg(s)} {s.senderName}</div></td>
                                                <td>
                                                    
                                                    {s.type === 'phone' ?
                                                        <i className="zmdi zmdi-phone"></i>
                                                    : null}

                                                    {s.type === 'messenger' ?
                                                        <i className="zmdi zmdi-comments"></i>
                                                    : null}

                                                    {s.type === 'person' ?
                                                        <i className="zmdi zmdi-face"></i>
                                                    : null}

                                                    {s.type === 'email' ?
                                                        <i className="zmdi zmdi-email"></i>
                                                    : null}

                                                    {s.type === 'personal' ?
                                                        <i className="zmdi zmdi-account-circle"></i>
                                                    : null}
                                                </td>
                                                <td>{moment(s.created).format('DD MMM YYYY')}</td>
                                            </tr>
                                        )
                                    })
                                : null}
                                                
                                            </tbody></table>

                            <div className="text-center">
                                {student.notes ?
                                    student.notes.length < student.noteCount ?
                                        <button className="btn btn-rounded btn-success" onClick={e => this.getStudentNotes()}><i className="zmdi zmdi-refresh"></i> Load More</button>
                                    : null
                                : null}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render(){
        let {student} = this.props;
        // console.log("Tags?", student.tags);
        return (
            <div className="panel customPanel student-panel-box">
                <div className="panel-body no-padding">
                    <div className="student-panel-header">
                        <div className="student-panel-header-left">
                            <div className="student-panel-header-image">
                                <a href="student-course.php">{this.renderImg(student)}</a>
                                <i className="fa fa-circle text-green"></i>
                            </div>
                            <div className="student-panel-header-desc">
                                <h3><Link to={`/student-course/${student.profileId}/${student.courseId}/${student.currentSubject}`} className="text-white">{student.name || student.pname}</Link></h3>
                                <p>{student.email} | {student.course}  | <a href={`#NotesModal-${student.id}`} onClick={e => this.getStudentNotes()} data-toggle="modal">{student.noteCount || 0} Notes</a></p>
                                <ul>
                                    {student.tags ?
                                        student.tags.map((t, i) => {
                                            return <li key={i} data-toggle="tooltip" title={t}><span>{t}</span></li>
                                        })
                                    : null}
                                </ul>
                            </div>
                        </div>
                        <div className="student-panel-header-right">
                            <div className="student-panel-header-right-top">
                                <div className="student-panel-header-times">
                                    <span className="student-panel-header-time-remaining"><i className="zmdi zmdi-timer"></i> Time to test: &nbsp;
                                        <Counter
                                            fullDays={true}
                                            timeclassName=""
                                            seconds={moment(student.testDate).diff(moment(), 'seconds')}
                                            direction="down"
                                            cu={student}
                                            subject={null}
                                            noStyle={true}
                                        />
                                    </span>
                                    {isNaN(student.ppd) ?
                                        <span className="student-panel-header-time-behind"><i className="zmdi zmdi-time-countdown"></i> {student.ppd}</span>
                                    :
                                        
                                        student.ppd < 0 ?
                                            <span className="student-panel-header-time-behind"><i className="zmdi zmdi-time-countdown"></i> {Math.floor(Math.abs(student.ppd))} days behind</span>
                                            :
                                            <span className="student-panel-header-time-ahead"><i className="zmdi zmdi-time-countdown"></i> {student.ppd} days ahead</span>
                                    }
                                    
                                </div>
                                <div className="student-panel-header-top-right-icons">
                                    <a href={`mailto:${student.email}`} className="btnround" data-toggle="tooltip" data-tip={student.email}><i className="zmdi zmdi-comments"></i></a>
                                    <a href={`tel:${student.phone || 0}`} className="btnround" data-toggle="tooltip" data-tip={student.phone || '-'}><i className="zmdi zmdi-phone"></i></a>
                                    <a href={`#OptionsModal-${student.id}`} className="btnround" data-toggle="modal"><i className="zmdi zmdi-more-vert"></i></a>
                                </div>
                            </div>
                            <div className="student-panel-header-bottom-icons">
                                <a href="#" className="text-red"><i className="zmdi zmdi-flag"></i> {student.redFlags}</a>
                                <a href="#" className="text-yellow"><i className="zmdi zmdi-flag"></i> {student.yellowFlags}</a>
                                <a href="#" className="text-orange"><i className="zmdi zmdi-flag"></i> {student.orangeFlags}</a>
                            </div>

                        </div>
                    </div>
                    <div className="student-stats-student-panel-wrap">
                        <div className="student-stats-student-panel">
                            <p>Last Active</p>
                            <h4>
                            {student.lastActive ?
                                moment(student.lastActive).format('DD MMM YYYY @ LT')
                            : null}</h4>
                        </div>
                        <div className="student-stats-student-panel">
                            <p>Hours Studied Yesterday</p>
                            <h4>{this.renderStudy()}</h4>
                        </div>
                        <div className="student-stats-student-panel">
                            <p>Avg Hours This Week</p>
                            <h4>{this.renderWeekStudy(7)}</h4>
                        </div>
                        <div className="student-stats-student-panel">
                            <p>Attendance (Two Weeks)</p>
                            <h4>{this.renderWeekStudy(14)}</h4>
                        </div>
                        <div className="student-stats-student-panel">
                            <p>Lectures finished per login</p>
                            <h4>{student.lecturePerLogin || '-'}</h4>
                        </div>
                        <div className="student-stats-student-panel">
                            <p>Subject Repeat</p>
                            <h4>{student.subjectAttempt - 1 || 0}</h4>
                        </div>
                        <div className="student-stats-student-panel">
                            <p>Extensions</p>
                            <h4>{student.deadlineExtensions || 0}</h4>
                        </div>
                    </div>
                    <div className="student-panel-subjects-wrap">
                        <div className="student-panel-subjects-list">
                            <ul>
                                {student.subjectOrder ? student.subjectOrder.map((s, i) => {
                                    return this.renderSubject(s, i)
                                }) : null}
                            </ul>
                        </div>
                        <div className="student-panel-subject-details-wrap">
                            {this.renderUserSubject()}
                        </div>
                    </div>
                </div>       
                {this.renderNotesModal()}
                {this.renderEditModal()}             
            </div>
        )
    }
}


const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    getStudents: (courseIds, filter, userId, token) => {
        dispatch(AdminActions.getStudents(courseIds, filter, userId, token));
    },
    getSingleUserSubject: (cuId, subjectId, token) => {
        dispatch(AdminActions.getSingleUserSubject(cuId, subjectId, token));
    },
    getStudentNotes: (cuId, skip, limit, token) => {
        dispatch(AdminActions.getStudentNotes(cuId, skip, limit, token));
    },
    saveStudent: (cuId, fields, token) => {
        dispatch(AdminActions.saveSearchStudent(cuId, fields, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Student));


// WEBPACK FOOTER //
// ./src/components/AdminConsole/Students/Student.js